export default "__VITE_ASSET__DhtWZdYj__";